import React from 'react';
import { useIntl } from 'react-intl';

import { MetaData, MetaDataType } from '@xingternal/pages-common';
import * as Types from '@xingternal/pages-graphql-types';

export type MetaDataContainerProps = {
  title?: string;
  image?: string;
  url?: string;
  focusType?: Types.Maybe<Types.EntityPageFocusType>;
  setDefault?: boolean;
};

const MetaDataContainer = ({
  title,
  image,
  url,
  focusType,
  setDefault,
}: MetaDataContainerProps) => {
  if (setDefault) {
    return <MetaData setDefault={setDefault} title={'XING'} />;
  }

  const intl = useIntl();
  const metaData: MetaDataType = {
    title: title
      ? intl.formatMessage({ id: 'EP_META_PAGE_TITLE' }, { pageTitle: title })
      : 'XING',
    url,
    image,
  };

  // adds default description per page focus
  switch (focusType) {
    case 'TOPIC_PAGE':
      metaData.description = intl.formatMessage(
        { id: 'EP_META_DESCRIPTION_TOPIC_PAGES' },
        { pageTitle: title }
      );
      break;
    case 'PUBLISHER':
      metaData.description = intl.formatMessage(
        { id: 'EP_META_DESCRIPTION_PUBLISHER_PAGES' },
        { pageTitle: title }
      );
      break;
    case 'COMPANY':
      metaData.description = intl.formatMessage(
        { id: 'EP_META_COMPANY_DESCRIPTION' },
        { pageTitle: title }
      );
      break;
    default:
      metaData.description = intl.formatMessage(
        { id: 'EP_META_DESCRIPTION_DEFAULT' },
        { pageTitle: title }
      );
      break;
  }

  return <MetaData setDefault={true} {...metaData} />;
};

export default MetaDataContainer;
